
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form2";
const form2State = namespace("Form2");

import Form2ProcessHeader from "@/components/process/Form2/components/Form2ProcessHeader.vue";
import Form2 from "@/components/process/Form2/components/pdf/Form2.vue"

import { form2StatusInfoType } from '@/types/Information/Form2';

@Component({
    components:{
        Form2ProcessHeader,
        Form2
    }
})
export default class PreviewForm2 extends Vue {

    @form2State.State
    public currentCaseId: string;

    stepsCompleted = {} as form2StatusInfoType;
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form2" }); 
    }
}
